export type Messages = string | string[] | Record<string, unknown> | undefined | null;

export const ensureErrorMessagesArray = (messages?: Messages): string[] => {
  let errorMessage: unknown = messages || ['No error message'];
  if (!Array.isArray(errorMessage)) {
    errorMessage = errorMessage !== null && typeof errorMessage === 'object'
      ? ['No error message']
      : [errorMessage];
  }
  return (errorMessage as unknown[]).map((item) => String(item));
};

export const ensureErrorMessagesArrayEmpty = (messages?: Messages): string[] => {
  let errorMessage: unknown = messages || [];
  if (!Array.isArray(errorMessage)) {
    errorMessage = errorMessage !== null && typeof errorMessage === 'object'
      ? []
      : [errorMessage];
  }
  return (errorMessage as unknown[]).map((item) => String(item));
};

export function serverError(messages?: Messages) {
  const errorMessage = ensureErrorMessagesArray(messages);
  return {
    type: 'SERVER_ERROR',
    errorMessage
  };
}

export const ensureString = (userShort?: unknown): string => {
  return typeof userShort === 'string' ? userShort : '';
};

export const ensureBoolean = (val?: unknown): boolean => {
  return typeof val === 'boolean' ? val : false;
};

export const ensureObject = (data?: unknown): Record<string, unknown> => {
  return data !== null && typeof data === 'object' && !Array.isArray(data)
    ? (data as Record<string, unknown>)
    : {};
};
